module.exports = __webpack_public_path__ + "assets/0977c48a492d1856000f267bdaaf3cb8.svg";